import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlService } from '../state/url.service';

@Injectable({
  providedIn: 'root'
})
export class CorrectionService {
  private readonly urlService = inject(UrlService);

  private readonly _correction$ = new BehaviorSubject<string>('');
  correctionState$: Observable<boolean> = this.urlService
    .getQueryParameterValue(UrlService.DISABLE_CORRECTION)
    .pipe(map((v) => Boolean(v)));
  correction$: Observable<string> = this._correction$;

  disableCorrection() {
    this.urlService.updateUrl(
      {
        [UrlService.DISABLE_CORRECTION]: true
      },
      null
    );
  }

  setCorrection(correction: string) {
    this._correction$.next(correction);
  }
}
